"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZebraItem = exports.ZebraList = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const base_react_components_1 = require("@navinc/base-react-components");
exports.ZebraList = styled_components_1.default.div.withConfig({ displayName: "reports-ZebraList", componentId: "reports-173cheb" }) `
  grid-template-columns: 1fr;
  list-style: none;
  margin: 0;
  padding: 0;

  & > * {
    padding: 8px;
  }

  & > *:nth-child(odd) {
    background-color: ${base_react_components_1.theme.neutral100};
  }
`;
const Item = styled_components_1.default.div.withConfig({ displayName: "reports-Item", componentId: "reports-1kynly7" }) `
  display: grid;
  grid-gap: 24px;

  @media print {
    grid-template-columns: 1fr 2fr;
  }

  @media (${base_react_components_1.theme.forLargerThanPhone}) {
    grid-template-columns: 1fr 2fr;
  }
`;
Item.displayName = 'Item';
const ZebraItem = (_a) => {
    var { label = '', children } = _a, props = __rest(_a, ["label", "children"]);
    return (react_1.default.createElement(Item, Object.assign({}, props),
        react_1.default.createElement(base_react_components_1.Copy, { bold: true }, label),
        react_1.default.createElement(base_react_components_1.Copy, null, children)));
};
exports.ZebraItem = ZebraItem;
exports.default = exports.ZebraList;
//# sourceMappingURL=index.js.map